// src/shared/components/Tooltip.js
import React, { useState } from 'react';

const Tooltip = ({ children, content, position = 'top' }) => {
  const [show, setShow] = useState(false);

  const positions = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </div>
      {show && (
        <div className={`absolute ${positions[position]} z-50`}>
          <div className="bg-gray-800 text-white text-sm rounded px-2 py-1 whitespace-nowrap">
            {content}
            <div className={`absolute ${
              position === 'top' ? 'top-full left-1/2 transform -translate-x-1/2 border-t-gray-800' :
              position === 'bottom' ? 'bottom-full left-1/2 transform -translate-x-1/2 border-b-gray-800' :
              position === 'left' ? 'left-full top-1/2 transform -translate-y-1/2 border-l-gray-800' :
              'right-full top-1/2 transform -translate-y-1/2 border-r-gray-800'
            } border-4 border-transparent`} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;